import { connect } from 'react-redux';

import JobShareModal from '../organisms/jobShareModal';
import { closeModal } from '../../../store/modals/actions';
import { getIsOpen, getModalParams } from '../../../store/modals/selectors';

import type { RootState } from '../../../store';

const mapStateToProps = (state: RootState) => ({
  visible: getIsOpen(state),
  params: getModalParams(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  onClose: () => dispatch(closeModal())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobShareModal); 